import script from "./_v-dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./_v-dropdown.vue?vue&type=script&setup=true&lang=js"

import "./_v-dropdown.vue?vue&type=style&index=0&id=2f262031&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f262031"]])

export default __exports__